module.exports = __webpack_public_path__ + "c103423.ttf";